import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastMessageOptions } from 'primeng/api';

import { GlobalCommunication } from '../../../global-communication.service';
import { AuthService } from '../../../services/auth.service';
import { SettingsService } from '../../../services/settings.service';

@Component({
  templateUrl: './change-password.component.html',
  standalone: false,
})
export class RestorePasswordComponent implements OnInit {
  public user: { email: string } = { email: '' };
  public errors: ToastMessageOptions[] = [];
  public newPassword: string = '';
  public confirmPassword: string = '';
  public token: string = '';

  constructor(
    protected router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    public settings: SettingsService,
    private globalCommunication: GlobalCommunication,
  ) {}

  public ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.token = params.token;
    });
  }

  public requestPass(): void {
    this.authService.restorePassword(this.user.email).subscribe(() => {
      this.router.navigate(['/auth/login']);
      this.globalCommunication.showMessages([
        {
          severity: 'success',
          detail: 'Check your email',
        },
      ]);
    });
  }

  public changePass(): void {
    this.authService.changePassword(this.newPassword, this.token).subscribe(() => {
      this.router.navigate(['/auth/login']);
      this.globalCommunication.showMessages([
        {
          severity: 'success',
          detail: 'Password was changed successfully',
        },
      ]);
    });
  }
}
